import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthServiceToken } from '../../services/auth/web-admin';
import { IAuthService } from '../../services/auth/interface';
import * as AuthActions from './actions';
import { mergeMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  StorageServiceToken,
  IStorageService,
} from '../../services/storage/interface';
import {
  LocationServiceToken,
  ILocationService,
} from '../../services/location/interface';

@Injectable({
  providedIn: 'root',
})
export class Effects {
  public constructor(
    private actions$: Actions,
    @Inject(AuthServiceToken) private authService: IAuthService,
    @Inject(StorageServiceToken) private storageService: IStorageService,
    @Inject(LocationServiceToken) private locationService: ILocationService,
  ) {}

  public login$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.ActionTypes.Login),
      mergeMap(({ payload }) =>
        this.authService.login(payload).pipe(
          tap((resp: any) => {
            this.storageService.setItem('accessToken', resp.accessToken);
            this.storageService.setItem('fullName', resp.fullName);
          }),
          map((resp: any) => new AuthActions.LoginSuccess(resp)),
          catchError((err) => of(new AuthActions.LoginFailure(err.error))),
        ),
      ),
    );
  });

  public logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.ActionTypes.Logout),
      mergeMap(({ payload }) =>
        this.authService.logout().pipe(
          tap(() => this.storageService.removeItem('accessToken')),
          map((resp) => new AuthActions.LogoutSuccess(resp)),
          tap(() => this.locationService.reload()),
          catchError((err) => of(new AuthActions.LogoutFailure(err))),
        ),
      ),
    );
  });

  public resolveSession$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.ActionTypes.ResolveSession),
      mergeMap(({ payload }) => {
        return this.authService.checkSession(payload).pipe(
          map((resp) => new AuthActions.ResolveSessionSuccess(resp)),
          catchError((err) => of(new AuthActions.ResolveSessionFailure(err))),
        );
      }),
    );
  });
}
